import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import type {
  SafetyEventViewType} from 'src/app/safety-events/SafetyEventForm';
import {
  SafetyEventForm
} from 'src/app/safety-events/SafetyEventForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {SafetyEventRouteService} from 'src/shared/services/RouterService/SafetyEventRouteService';
import {SafetyEventDocumentTitle} from 'src/app/safety-events/safetyEventHelpers';

export const ViewSafetyEventPage: React.FC = () => {
  useSetDocumentTitle(SafetyEventDocumentTitle);
  const {id, view} = useParams();

  const router = useMemo(
    () => new SafetyEventRouteService(false, 'view', {view: view as SafetyEventViewType}),
    [view]
  );

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.SafetyEvents}>
      <SafetyEventForm
        mode="view"
        id={+id!}
        view={view as SafetyEventViewType}
        router={router}
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.SafetyEventView(':id', ':view'),
  element: <ViewSafetyEventPage />,
  module: ModuleEnum.SafetyEvent,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

